import React, { useEffect, useState } from 'react';
import { useCoverLetter } from '../../../context/CoverLetterContext';
import LoadingIcon from '../../../images/spinner.svg';
import WpAPI from '../../../WpApi';
import { stripTags } from '../../../helper';
const WorkHistoryForm = ({ data, save }) => {

  const [checkField, setCheckField] = useState('');
  const [matchedTitles, setMatchedTitles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const removeError = (e) => {
    setError({ ...error, [e.target.name]: "" });
  }

  const fieldFocus = e => {
    setCheckField(e.target.name);
    removeError(e);
  }

  const fieldBlur = e => {
    setCheckField('');
  }
  const jobSelected = (v) => {
    save({ work_history: v });
    setMatchedTitles([])
}
  return (<div className="screen-block">
    {/* //Duplicate screen start  */}
    <div className="form-row">
      <div className="field-wrap">
        <label htmlFor="work_history" className={`label${checkField == 'work_history' ? ' label-focus' : ''}`}>Job Title</label>
        <input
          type="text"
          className="validate"
          name="work_history"
          id="work_history"
          placeholder="Customer Service Representative"
          value={data.work_history}
          onChange={(e) => {
            if (e.target.value.trim().length > 2) {
              setLoading(true)
              WpAPI.getJobTitles(e.target.value.trim()).then(res => {
                setMatchedTitles(res)
                setLoading(false)
              })
            }else if(e.target.value.trim().length == 0){
              setMatchedTitles([])
          }
            save({ work_history: stripTags(e.target.value) });
          }}
          onFocus={(e) => {
            if(e.target.value.length == 0) setMatchedTitles([])
            fieldFocus(e)}
          }
          onBlur={(e) => fieldBlur(e)}
        />
        <div className="load-listing">{loading ? <LoadingIcon /> : ""}</div>
          {matchedTitles.length > 0 && <>
            <div className="load-listing close-listing" onClick={() => setMatchedTitles([])}>{loading ? "" : <i className='icon-cross-icon'></i>}</div>
            <div className="job-list">
              <ul>
                {matchedTitles.map((v, n) => <li key={n} onClick={() => jobSelected(v)}><span>{v}</span></li>)}
              </ul>
            </div></>}
      </div>
    </div>
    {/* //Duplicate screen end  */}
  </div>)
}

export default WorkHistoryForm;